$(function(){

  const
    $window = $(window),
    $headerContainer = $(".l-headerContainer"),
    $header = $(".l-header"),
    $topMessage = $(".l-topMessage"),
    $drawerButton = $(".js-toggleDrawer"),
    $overlay = $(".js-drawerOverlay"),
    $topMessageCloseButton = $(".js-closeTopMessage"),
    topMessageHidePos = 100;

  let
    topMessageHeight = $topMessage.outerHeight(),
    headerHeight = $header.outerHeight(),
    isDrawerShow = false,
    isTopMessageShow = true,
    isDuringAnimationTopMessage = false,
    crtTopMessageHeight = topMessageHeight,
    userClosedMessage = false; // ユーザーが閉じる操作をしたかどうか

  // ドロワーを開く
  const showDrawer = function(){
    $headerContainer.addClass('is-show');
    isDrawerShow = true;
  };

  // ドロワーを閉じる
  const hideDrawer = function(){
    $headerContainer.removeClass('is-show');
    isDrawerShow = false;
  };

  // メッセージを閉じるボタン
  $topMessageCloseButton.on("click", function(){
    userClosedMessage = true;
    hideTopMessage();
  });

  // ドロワートグルボタン
  $drawerButton.on("click", function(){
    if (isDrawerShow) {
      hideDrawer();
    } else {
      showDrawer();
    }
  });

  // オーバーレイ
  $overlay.on("click", function(){
    hideDrawer();
  });

  if (!topMessageHeight) {
    topMessageHeight = 0;
  }
  document.documentElement.style.setProperty('--top-message-height', `${topMessageHeight}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

  const showTopMessage = function(){
    // すでに表示中ならreturn
    // ユーザーが閉じる操作をしたなら以降は開かない
    if (isTopMessageShow || userClosedMessage) {
      return;
    }

    // 表示中ステータス
    isTopMessageShow = true;
    // animation中ステータス
    isDuringAnimationTopMessage = true;
    // 現在のメッセージエリアの高さを、本来の高さに設定
    crtTopMessageHeight = topMessageHeight;
    // css変数をset
    document.documentElement.style.setProperty('--top-message-height', `${crtTopMessageHeight}px`);

    $topMessage.slideDown().queue(function() {
      // animation中ステータス 解除
      isDuringAnimationTopMessage = false;
      $(this).dequeue();
    })

  };

  const hideTopMessage = function(){
    // すでに非表示中ならreturn
    if (!isTopMessageShow) {
      return;
    }

    // 非表示中ステータス
    isTopMessageShow = false;
    // animation中ステータス
    isDuringAnimationTopMessage = true;
    // 現在のメッセージエリアの高さを、0に設定
    crtTopMessageHeight = 0;
    // css変数をset
    document.documentElement.style.setProperty('--top-message-height', `${crtTopMessageHeight}px`);

    $topMessage.slideUp().queue(function() {
      // animation中ステータス 解除
      isDuringAnimationTopMessage = false;
      $(this).dequeue();
    });

  };

  $window.on("scroll", function() {
    // アニメーション途中ならreturn
    if (isDuringAnimationTopMessage) {
      return;
    }

    const currentPos = $window.scrollTop();

    // 設定値よりスクロール量が多かったらhide
    if (currentPos-crtTopMessageHeight > topMessageHidePos) {
      hideTopMessage();
      return;
    }

    // 設定値よりスクロール量が少なかったらshow
    showTopMessage();
  });

  // ドロワー内リンク（ページ内リンクなら閉じる）
  $headerContainer.on("click", "a", function(e){
    var href = $(this).attr("href");
    // hrefが#で始まってて、かつ長さが1以上なら（"#" とか "#section"）
    if (href && href.charAt(0) === "#") {
      hideDrawer();
    }
  });

});
